import mixpanelCommonEvents from 'top20common/distribution/plugins/mixpanel';
import analyticsCommon from 'top20common/distribution/services/analytics/common';

import jobsOverview from './jobs-overview.analytics';
import profile from './profile.analytics';

export default function(multianalytics) {
  let analytics = analyticsCommon(multianalytics);

  analytics.trackApplyToJobClicked = function() {
    analytics.trackEvent({action: 'Apply To Job Clicked'});
  };

  analytics.trackJobPageVisit = function(utmMedium) {
    analytics.trackEvent({
      action: 'Job Detail Page Visit',
      properties: {
        source: utmMedium === 'email' ? 'job floating' : 'normal'
      }
    });
  };

  analytics.trackPreviewPDFClicked = function(profileCompleteness) {
    analytics.trackEvent({
      action: 'Preview PDF Clicked',
      properties: {
        'Profile completeness': `${profileCompleteness}%`
      }
    });
  };

  analytics.trackNavChangePasswordClicked = function() {
    analytics.trackEvent({action: 'Nav Change Password Clicked'});
  };

  analytics.trackNavLogoutClicked = function() {
    analytics.trackEvent({action: 'Nav Logout Clicked'});
  };

  analytics.trackNavMenuClicked = function() {
    analytics.trackEvent({action: 'Nav Menu Clicked'});
  };

  analytics.trackNavLoginClicked = function() {
    analytics.trackEvent({action: 'Nav Login Clicked'});
  };

  analytics.trackNavSignUpClicked = function() {
    analytics.trackEvent({action: 'Nav Sign Up Clicked'});
  };

  analytics.trackReferByEmailClicked = function() {
    analytics.trackEvent({action: 'Refer By Email Clicked'});
  };

  analytics.ReferByEmailSendClicked = function(anonymous) {
    analytics.trackEvent({
      action: 'Refer By Email Send Clicked',
      properties: {
        Anonymous: anonymous ? 'yes' : 'no'
      }
    });
  };

  analytics.trackReferralLinkFieldClicked = function() {
    analytics.trackEvent({action: 'Referral Link Field Clicked'});
  };

  return {
    ...analytics,
    ...mixpanelCommonEvents(analytics),
    ...profile(analytics),
    ...jobsOverview(analytics)
  };
}
